module.exports = "https://www.gc-qa.gnp.com.mx/be0401e4a1e38033d9b90872b711664b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-27.png
// module id = 950
// module chunks = 0 1